<template>
  <classify-index :type="0"></classify-index>
</template>

<script>


import ClassifyIndex from "@view/components/classify/classify-index.vue";

export default {
  name: "classify",
  components: {ClassifyIndex},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
